<script>
  import { onMount } from "svelte";
  import { navigate } from "svelte-routing";
  import axios from "axios";
  import {
    Modal,
    ModalBody,
    ModalFooter,
    ModalHeader,
  } from "@/component/Modal";

  import { isMobile } from "@/function/media.js";
  import { statusState } from "@/stores/index.js";
  import { format } from "@/function/format.js";

  export let params = false; // Pass decrypted params from client

  let textPhoneNumber = "";
  let enableText = true;
  let validated = false;
  let selectedPort = 0;
  let initiateCharge = false;

  $: {
    if (enableText && textPhoneNumber.length === 0) {
      validated = false;
    } else {
      validated = true;
    }
  }

  $: {
    console.log("[*] initiateCharge:", initiateCharge);
  }

  let billingName = "",
    billingAddress = "",
    billingCity = "",
    billingState = "",
    billingZip = "",
    billingCountry = "US",
    billingCCNum = "",
    billingExp = "",
    billingCCV = "";

  // Demo parameters
  if (process.env.DEV_MODE) {
    console.log("[*] DEV_MODE:", process.env.DEV_MODE);
    billingName = "Joe Blow";
    billingAddress = "123 Main St";
    billingCity = "Anytown";
    billingState = "CA";
    billingZip = "12345";
    billingCountry = "US";
    billingCCNum = "5555555555554444";
    billingExp = "0227";
    billingCCV = "123";
  }

  let open = false;

  onMount(() => {
    const inputs = document.querySelectorAll(".mini_input.autotab");

    inputs.forEach((input) => {
      format.check.call(input, inputs);
      input.addEventListener("keyup", format.check.bind(input, inputs));
    });
  });

  const onModelStateChange = (state) => {
    console.log("[*] Modal opened", state);
  };

  const toggle = () => {
    open = !open;

    if (!open) {
      initiateCharge = false;
    }
  };

  window.openModal = toggle;

  async function validatePaymentDetails(e) {
    e.preventDefault();

    // Do form validation
    if (
      /^\d{4}/i.test(billingExp) ||
      /^(0[1-9]|1[0-2])[/](0[1-9]|[1-2][0-9]|3[0-1])$/.test(billingExp)
    ) {
      open = true;
    } else {
      throw Error("Validation Errors: Invalid expiration date");
    }
  }

  async function processPayment(e) {
    statusState.resetStatus();

    try {
      console.log("[*] Processing payment...", billingExp);
      let billingExpMonth, billingExpYear;

      if (
        /^\d{4}/i.test(billingExp) ||
        /^(0[1-9]|1[0-2])[/](0[1-9]|[1-2][0-9]|3[0-1])$/.test(billingExp)
      ) {
        if (/^\d{4}/i.test(billingExp)) {
          billingExpMonth = billingExp.substring(0, 2);
          billingExpYear = billingExp.substring(2, 4);
        } else if (billingExp.includes("/")) {
          [billingExpMonth, billingExpYear] = billingExp.split("/");
        }
      } else {
        throw Error("Validation Errors: Invalid expiration date");
      }

      const res = await axios.post(`${process.env.BACKEND_URL}/api/v1/start`, {
        billingName,
        billingAddress,
        billingCity,
        billingState,
        billingZip,
        billingCountry,
        billingCCNum,
        billingExpMonth,
        billingExpYear,
        billingCCV,
        unitId: params.cid, // Passed from payment page
        connectorId: params.port, // Passed from payment page
      });

      if (!res.data.sessionId) {
        throw Error("No event ID returned from server");
      }

      if (res.data.validationErrors) {
        const errors =
          "Validation Errors: " +
          res.data.validationErrors
            .map((e) => {
              return e.msg;
            })
            .join(", ");

        console.log("[*] Validation Errors:", errors);
        throw Error(errors);
      }

      // Setup SSE to watch for status updates
      statusState.watchEvent(res.data.sessionId);
    } catch (e) {
      console.error("[*] ERROR:", e.message);
      setTimeout(() => {
        statusState.showError(e.message);
      }, 100);
    }
  }

  const selectPort = (e, port) => {
    e.preventDefault();
    console.log("[*] Port selected:", port);
    selectedPort = port;
  };

  const onSuccess = () => {
    console.log("[*] Success!");
    navigate("/success", { replace: true });
  };
</script>

{(console.log("[*] Mobile UI detected:", $isMobile), "")}

<div class="container" class:mobile={$isMobile}>
  <h1 style="text-align: center">Quick Pay</h1>
  <p>
    Initiate charging of your EV via credit card (no RFID or account needed)
  </p>

  <div class="row">
    <div class="col-md-4 col-sm-6 content-card">
      <div class="notice-card-shadow">
        <div class="notice-card card-information">
          <div class="content">
            <h3>Notice</h3>

            <p class="description">
              We'll <b style="text-decoration:underline"> temporarily </b> authorize
              a $25 charge on your card to cover your charging needs. Once your charging
              session is complete, you'll only be charged the actual amount.
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!--<hr />-->

  <div class="address">
    <label class="address" for="address"><b>Address</b></label>
    <input
      type="text"
      placeholder="Street Address"
      class="mini_input"
      name="address"
      id="address"
      bind:value={billingAddress}
    />
    <div class="city_state_zip-container">
      <input
        type="text"
        placeholder="City"
        class="mini_input city"
        name="city"
        id="city"
        bind:value={billingCity}
      />
      <select
        class="mini_input dropdown state"
        name="state"
        id="state"
        style=""
        bind:value={billingState}
      >
        <option value="" disabled selected>Select a state</option>
        <option value="AL">Alabama</option>
        <option value="AK">Alaska</option>
        <option value="AZ">Arizona</option>
        <option value="AR">Arkansas</option>
        <option value="CA">California</option>
        <option value="CO">Colorado</option>
        <option value="CT">Connecticut</option>
        <option value="DE">Delaware</option>
        <option value="DC">District Of Columbia</option>
        <option value="FL">Florida</option>
        <option value="GA">Georgia</option>
        <option value="HI">Hawaii</option>
        <option value="ID">Idaho</option>
        <option value="IL">Illinois</option>
        <option value="IN">Indiana</option>
        <option value="IA">Iowa</option>
        <option value="KS">Kansas</option>
        <option value="KY">Kentucky</option>
        <option value="LA">Louisiana</option>
        <option value="ME">Maine</option>
        <option value="MD">Maryland</option>
        <option value="MA">Massachusetts</option>
        <option value="MI">Michigan</option>
        <option value="MN">Minnesota</option>
        <option value="MS">Mississippi</option>
        <option value="MO">Missouri</option>
        <option value="MT">Montana</option>
        <option value="NE">Nebraska</option>
        <option value="NV">Nevada</option>
        <option value="NH">New Hampshire</option>
        <option value="NJ">New Jersey</option>
        <option value="NM">New Mexico</option>
        <option value="NY">New York</option>
        <option value="NC">North Carolina</option>
        <option value="ND">North Dakota</option>
        <option value="OH">Ohio</option>
        <option value="OK">Oklahoma</option>
        <option value="OR">Oregon</option>
        <option value="PA">Pennsylvania</option>
        <option value="RI">Rhode Island</option>
        <option value="SC">South Carolina</option>
        <option value="SD">South Dakota</option>
        <option value="TN">Tennessee</option>
        <option value="TX">Texas</option>
        <option value="UT">Utah</option>
        <option value="VT">Vermont</option>
        <option value="VA">Virginia</option>
        <option value="WA">Washington</option>
        <option value="WV">West Virginia</option>
        <option value="WI">Wisconsin</option>
        <option value="WY">Wyoming</option>
      </select>

      <input
        type="text"
        placeholder="Zip"
        class="mini_input zip"
        name="zip"
        id="zip"
        bind:value={billingZip}
      />
      <input
        type="hidden"
        placeholder="Country"
        class="mini_input"
        name="country"
        id="country"
        bind:value={billingCountry}
        disabled
      />
    </div>
  </div>

  <div class="cc_card_info">
    <label for="cc"><b>Credit Card #</b></label>
    <input
      type="text"
      placeholder="Credit Card Number"
      class="mini_input"
      name="cc"
      id="cc"
      required
      autocomplete="cc-number"
      bind:value={billingCCNum}
    />
    <label
      class="name credit-card-account-holder-name-input"
      for="ppw-accountHolderName"
    >
      <b>Name on Card</b>
    </label>
    <input
      type="text"
      placeholder="Name"
      class="mini_input"
      name="ppw-accountHolderName"
      id="name"
      autocomplete="off"
      bind:value={billingName}
    />
  </div>

  <div class="validate">
    <label for="cc-exp"><b>Expiration</b></label>
    <span class="cc_expiration">
      <input
        type="text"
        name="cc_expiration"
        maxlength="5"
        class="mini_input cc_expiration autotab 1"
        style="width:60px"
        autocomplete="cc-exp"
        bind:value={billingExp}
      />
    </span>

    <label for="cc-exp" style="margin-left: 30px;"><b>CCV</b></label>
    <span class="cc_ccv">
      <input
        type="text"
        maxlength="4"
        class="mini_input cc_ccv autotab 2"
        style="width:60px"
        required
        autocomplete="cc-csc"
        bind:value={billingCCV}
      />
    </span>
  </div>

  <hr />

  <div class="group form-group opt-in">
    <div class="checkbox">
      <input
        type="checkbox"
        id="opt-in-text"
        name="opt-in-text"
        bind:checked={enableText}
      />
      <label class="opt-in-text" for="opt-in-text" style="display: inline;">
        I want to receive a text notification with my session summary
      </label>
    </div>

    <div
      class={`form-group telephone-number ${enableText ? "show" : "hidden"}`}
      id="phone-field"
      style="padding: 0;"
    >
      <input
        type="tel"
        id="phone"
        name="phone"
        bind:value={textPhoneNumber}
        placeholder="Enter your phone number"
      />
    </div>
  </div>

  <button
    type="submit"
    class="submit-button"
    disabled={!validated}
    on:click={validatePaymentDetails}
  >
    Authorize Payment
  </button>
</div>

<Modal
  isOpen={open}
  {toggle}
  fullscreen={false}
  size={"lg"}
  onModelOpen={onModelStateChange}
  on:success={onSuccess}
>
  <ModalHeader {toggle}>Authorization Status</ModalHeader>
  <ModalBody>
    {#if !initiateCharge}
      <div class="container">
        <div class="notice">
          <p>
            <strong>Notice:</strong> Select a charging port and confirm to start
            charging your EV.
          </p>
        </div>

        <div class="port-selection">
          <div class="port-container">
            <button
              class="port"
              class:active={selectedPort === 1}
              on:click={(e) => selectPort(e, 1)}
            >
              <span>1</span>
              <svg class="ring" viewBox="0 0 36 36">
                <circle class="green-ring" cx="18" cy="18" r="16"></circle>
              </svg>
            </button>
            <button
              class="port"
              class:active={selectedPort === 2}
              on:click={(e) => selectPort(e, 2)}
            >
              <span>2</span>
              <svg class="ring" viewBox="0 0 36 36">
                <circle class="green-ring" cx="18" cy="18" r="16"></circle>
              </svg>
            </button>
          </div>

          <div>
            {#if selectedPort}
              <p>
                <span id="selected-port">Port {selectedPort}</span> has been selected.
              </p>
            {/if}
          </div>

          <button
            class="submit-button"
            disabled={!selectedPort}
            on:click={(e) => {
              console.log("[*] Initiating charge...");
              e.preventDefault();
              initiateCharge = true;
              processPayment();
            }}
          >
            {#if selectedPort}
              Start charging on port {selectedPort}
            {:else}
              Select a port
            {/if}
          </button>
        </div>
      </div>
    {:else}
      <div class="container" class:mobile={$isMobile}>
        <div class="progress-container">
          <div class="circle payment">Authorizing Payment</div>
          <div class="circle charge">Plug-in Vehicle</div>
        </div>
        <div class="error">
          <b style="color: red; text-decoration:underline;">ERROR</b>
          <div>{$statusState.message}</div>
        </div>
      </div>
    {/if}
  </ModalBody>
  <ModalFooter>
    <div style="margin-top: 10px;text-align: center;">
      <pre style="white-space: initial;color: white;margin-bottom:0px">
        {JSON.stringify($statusState, null, 4)}
      </pre>
    </div>
  </ModalFooter>
</Modal>

<style>
  :global(.modal) {
    padding-top: 20%;
  }

  :global(.modal-footer) {
    height: 50px;
    overflow-y: scroll;
    font-size: 0.8em;
    margin: 0px;
    padding: 0px !important;
    justify-content: center !important;
  }
  :global(.modal-backdrop.show) {
    opacity: 0.8 !important;
  }

  :global(.container > .error) {
    display: none;
    padding-top: 30px;
  }

  :global(.progress-container .circle.success) {
    border-color: var(--line-border-success) !important;
  }

  :global(.progress-container .circle.error) {
    border-color: var(--line-border-error) !important;
  }

  :global(
      .progress-container .circle.success span::before,
      .progress-container .circle.error span::before
    ) {
    display: none;
  }

  .mobile .col-sm-6 {
    width: 100%;
  }

  .col-sm-6 {
    width: 50%;
  }

  label.address {
    margin-top: 0px;
  }

  .mini_input {
    width: 15px;
    font-size: 1em;
    border: none;
    background: none;
    box-shadow: none;
    padding: 3px 0 5px 5px;
    border: none;
    background: #f1f1f1;
  }

  .container {
    padding: 16px;
  }

  .container {
    margin-top: 15px;
    text-align: center;
    margin: auto;
  }

  label {
    text-align: left;
    width: 100%;
  }

  .validate label {
    width: unset;
  }
  .validate .cc_expiration * {
    display: inline-block;
    vertical-align: middle;
  }
  .validate .cc_expiration input[type="text"] {
    padding: 5px;
  }

  .city_state_zip-container {
    display: flex;
    gap: 10px;
  }

  .mobile .city_state_zip-container {
    flex-wrap: wrap;
  }

  .mini_input.dropdown.state {
    width: 180px;
    height: 54px;
    margin-top: 5px;
    flex: 10%;
  }

  .mini_input.city {
    width: 180px;
    height: 54px;
    margin-top: 5px;
    flex: 100%;
  }
  .mini_input.zip {
    width: 180px !important;
    height: 54px;
    margin-top: 5px;
    flex: 180px;
  }

  .address {
    margin-top: 50px;
  }

  /* Full-width input fields */
  .address input[type="text"] {
    width: 100%;
    padding: 15px;
    margin: 5px 0 22px 0;
    display: inline-block;
  }

  .address input[type="text"]:focus {
    background-color: #ddd;
    outline: none;
  }
  .cc_card_info {
    margin-top: 50px;
  }
  .cc_card_info input[type="text"] {
    width: 100%;
    padding: 15px;
    margin: 5px 0 22px 0;
    display: inline-block;
  }

  .cc_card_info input[type="text"]:focus {
    background-color: #ddd;
    outline: none;
  }

  /* Overwrite default styles of hr */
  hr {
    border: 1px solid #f1f1f1;
    margin-bottom: 25px;
  }

  .submit-button:hover {
    opacity: 1;
  }

  :root {
    --line-border-success: #16bb3f;
    --line-border-error: #e80808;
    --line-border-empty: #e0e0e0;
    --port-size: 100px;
  }

  .progress-container::before {
    content: "";
    background: var(--line-border-empty);
    position: absolute;
    top: 50%;
    left: 0;
    transform: translateY(-50%);
    height: 4px;
    width: 100%;
    z-index: -1;
  }

  .progress-container {
    display: flex;
    justify-content: space-between;
    position: relative;
    margin-bottom: 30px;
    max-width: 100%;
    width: 50%;
    margin: auto;
  }

  .circle {
    background: #fff;
    color: #999;
    border-radius: 50%;
    height: 100px;
    width: 100px;
    display: flex;
    align-items: center;
    justify-content: center;
    border: 7px solid var(--line-border-empty);
    transition: 0.4s ease;
    font-size: 0.8em;
  }

  .circle span {
    position: relative;
  }

  .circle span::before {
    animation: 1.5s linear infinite s-FPHjsjh_NVQL-spinner;
    animation-play-state: inherit;
    border: solid 7px #cfd0d1;
    border-bottom-color: #1c87c9;
    border-radius: 50%;
    content: "";
    height: 100px;
    width: 100px;
    position: absolute;
    top: 0px;
    left: -36px;
    transform: translate3d(-50%, -50%, 0);
    will-change: transform;
  }

  .progress-container {
    width: 80%;
  }

  .mobile .circle {
    height: var(--port-size);
    width: var(--port-size);
    border: 4px solid var(--line-border-empty);
  }

  .mobile .circle span::before {
    height: var(--port-size);
    width: var(--port-size);
    border: 4px solid var(--line-border-empty);
  }

  .notice-card-shadow {
    position: relative;
  }

  .content-card {
    margin-top: 30px;
    margin-left: 50px;
    margin: auto;
  }

  .notice-card {
    border-radius: 10px;
  }

  .notice-card {
    border-radius: 8px;
    box-shadow: 0 2px 8px rgba(164, 164, 0, 0.5);
    background-color: #ffffff;
    color: #252422;
    margin-bottom: 20px;
    position: relative;
    z-index: 1;
    background: #fceba6;
  }

  .notice-card.card-information .content {
    padding: 5px 55px;
    text-align: center;
  }

  .notice-card .content {
    padding: 20px 20px 10px 20px;
  }

  .notice-card-shadow:before {
    background-position: center bottom;
    background-repeat: no-repeat;
    background-size: 100% 100%;
    bottom: -12%;
    content: "";
    display: block;
    left: -12%;
    position: absolute;
    right: 0;
    top: 0;
    z-index: 0;
  }

  h3 {
    font-size: 1.3em;
    font-weight: 900;
    line-height: 1.5em;
    width: auto;
    color: #008000;
  }

  .notice-card .description {
    font-size: 16px;
    color: #66615b;
  }

  @keyframes spinner {
    0% {
      transform: translate3d(-50%, -50%, 0) rotate(0deg);
    }
    100% {
      transform: translate3d(-50%, -50%, 0) rotate(360deg);
    }
  }
</style>
